module.exports = __webpack_public_path__ + "img/about-m-slide-11.a0148c17.jpg";